import { TypeRequest } from "../common/enums/AllEnums";
import { IQuestionGroup } from "../interfaces/IQuestion";
import { IResponse } from "../interfaces/IResponse";
import { BisApiRequest } from "./apis";

export const GetQuestionsGroupByUserID = (): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Formulario/ObtenerGrupoPreguntasByUsuario`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetQuestionsGroupByID = (questionGroupID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Formulario/ObtenerGrupoPreguntaByID?GrupoPreguntaID=${questionGroupID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const DeactivateQuestionsGroupByID = (questionGroupID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Formulario/DesactivarGrupoPregunta?GrupoPreguntaID=${questionGroupID}`, TypeRequest.put).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}
export const UpdateQuestionsGroup = (questionGroup: IQuestionGroup): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Formulario/ActualizarGrupoPregunta`, TypeRequest.put, questionGroup).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const InsertAQuestionsGroup = (questionGroup: IQuestionGroup): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Formulario/InsertarGrupoPregunta`, TypeRequest.post, questionGroup).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}